import * as R from 'ramda';
import { submitAppDomain } from './utils';
import {
    SET_BASE_PATH,
    SET_CUSTOMER_NAME,
    SET_FROM_EDITOR,
    SET_FROM_SURVEY,
    SET_SURVEY_ID,
    SET_FROM_ORGANIZATION,
    SET_ORGANIZATION_ID,
    REMOVE_PATH
} from './constants';

const defaultState = {
    basePath: '',
    customerName: '',
    fromEditor: false,
    fromSurvey: false,
    fromOrganization: false,
    surveyId: null,
    organizationId: null,
    submitAppDomain
};

const path = (state = defaultState, { type, payload }) => {
    switch (type) {
        case SET_BASE_PATH:
            return R.merge(state, { basePath: payload });
        case SET_CUSTOMER_NAME:
            return R.merge(state, { customerName: payload });
        case SET_FROM_EDITOR:
            return R.merge(state, { fromEditor: payload });
        case SET_FROM_SURVEY:
            return R.merge(state, { fromSurvey: payload });
        case SET_SURVEY_ID:
            return R.merge(state, { surveyId: payload });
        case SET_FROM_ORGANIZATION:
            return R.merge(state, { fromOrganization: payload });
        case SET_ORGANIZATION_ID:
            return R.merge(state, { organizationId: payload });
        case REMOVE_PATH:
            switch (payload) {
                case 'fromEditor':
                    return R.merge(state, { fromEditor: false });
                case 'fromSurvey':
                    return R.merge(state, { fromSurvey: false });
                case 'fromOrganization':
                    return R.merge(state, { fromOrganization: false });
                case 'all':
                    return R.merge(state, { fromEditor: false, fromSurvey: false, fromOrganization: false });
                default:
                    return state;
            }
        default:
            return state;
    }
};

export default path;
